import { useState } from 'react';
import api, { ApiError } from '../../api/client.js';

export default function ChangePasswordPanel({ showToast }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    if (submitting) return;

    setError('');

    if (newPassword !== confirmPassword) {
      setError('كلمتا المرور غير متطابقتين');
      return;
    }

    setSubmitting(true);
    try {
      await api.changePassword(currentPassword, newPassword);
      // The server ends every session for this account on a password change,
      // including this one, so the app returns to the login screen.
      showToast('تم تغيير كلمة المرور. يرجى تسجيل الدخول من جديد.');
      window.location.href = '/';
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'تعذّر تغيير كلمة المرور');
      setSubmitting(false);
    }
  }

  return (
    <section className="panel">
      <div className="panel-header">
        <div>
          <h2>تغيير كلمة المرور</h2>
          <p>لحسابك الحالي. ستنتهي جلساتك على جميع الأجهزة بعد التغيير.</p>
        </div>
      </div>

      <div className="panel-body">
        <form onSubmit={handleSubmit} style={{ maxWidth: '380px' }} noValidate>
          {error && <div className="form-error">{error}</div>}

          <div className="field">
            <label htmlFor="current-password">كلمة المرور الحالية</label>
            <input
              id="current-password"
              type="password"
              dir="ltr"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <div className="field">
            <label htmlFor="change-new-password">كلمة المرور الجديدة</label>
            <input
              id="change-new-password"
              type="password"
              dir="ltr"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              autoComplete="new-password"
              required
            />
            <p className="hint">10 أحرف على الأقل.</p>
          </div>

          <div className="field">
            <label htmlFor="confirm-password">تأكيد كلمة المرور الجديدة</label>
            <input
              id="confirm-password"
              type="password"
              dir="ltr"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete="new-password"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? '...جاري الحفظ' : 'تغيير كلمة المرور'}
          </button>
        </form>
      </div>
    </section>
  );
}
